/**
 * 多言語化対応用
 * 項目名の翻訳対応データ定義
 */
export default {
  email: "E-mail",
  lastName: "Last Name",
  firstName: "First Name",
}
